//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/TaggedObject.js";
import "../no/SelectPartList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AllowRotation",1,0],[1,"PointsSelection",0,"SelectPartList",0]],[[["width"],"UpdateRecWidth",{},1,0],[["height"],"UpdateRecHeight",{},1,0],[["angle"],"UpdateRecAngle",{},1,0],[[],"ResetData",{},0,0],[[],"UpdateRectangle",{},0,0],[["width","height"],"SetWidthHeight",{},2,0],[[],"ResetWidthHeight",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.LineDesigner.PickRectanglePointsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.PickRectanglePointsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;